import * as actions from './actions'
import { state } from './state'
import * as effects from './effects'

export default {
  actions,
  state,
  effects,
}
